import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";
import SearchSelect from "../../../../components/private/searchselect";

const CreateInformacionGeneral = () => {

  const { authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
      id_asignacion_contrato: "",
      tipo_cobertura: "",
      lugar_ejecucion: "",
      cobertura: "",
      plazo_pago: ""
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [contratosAsignados, setContratosAsignados] = useState([]);
  const [contratoSeleccionado, setContratoSeleccionado] = useState(null);

  const formatoMoneda = (valor) => {

    if (
        valor === null ||
        valor === undefined ||
        valor === ""
    ) {
        return "";
    }

    const valorLimpio = String(valor).split(".")[0];

    return `$${valorLimpio.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
};


  // CARGAR CONTRATOS ASIGNADOS
  useEffect(() => {

      const loadData = async () => {

          try {

              const res = await authFetch(
                  ENDPOINTS.get_contratos_asignados
              );

              if (res.success) {
                  setContratosAsignados(res.data);
              }

          } catch (error) {

              console.error(error);
              setError("No fue posible cargar los contratos asignados.");

          }

      };

      loadData();

  }, [authFetch]);


  const contratoOptions = contratosAsignados.map((item) => ({
    value: item.id_asignacion_contrato,
    label: `${item.num_contrato} - ${item.programa}`
  }));

  const handleContratoChange = (idAsignacion) => {

      const contrato = contratosAsignados.find(
          (c) =>
              Number(c.id_asignacion_contrato) === Number(idAsignacion)
      );

      if (!contrato) {

          setContratoSeleccionado(null);

          setFormData({
              id_asignacion_contrato: "",
              tipo_cobertura: "",
              lugar_ejecucion: "",
              cobertura: "",
              plazo_pago: ""
          });

          return;
      }

      setContratoSeleccionado(contrato);

      setFormData((prev) => ({
          ...prev,
          id_asignacion_contrato: contrato.id_asignacion_contrato
      }));

  };
  // ======================================
  // INPUTS
  // ======================================

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

  };

  // ======================================
  // SUBMIT
  // ======================================

  const handleSubmit = async (e) => {

    e.preventDefault();

    setError("");
    setSuccess("");

    // VALIDACIONES

    if (!formData.id_asignacion_contrato) {
      setError("Debe seleccionar un contrato asignado");
      return;
    }


    if (!formData.tipo_cobertura) {
      setError("Debe ingresar el tipo de cobertura");
      return;
    }


    if (!formData.lugar_ejecucion) {
      setError("Debe ingresar el lugar de ejecución");
      return;
    }

    if (formData.cobertura === "" || formData.cobertura === null || formData.cobertura === undefined) {
        setError("Debe ingresar la cobertura");
        return;
    }

    if (!formData.plazo_pago) {
        setError("Debe ingresar el plazo de pago");
        return;
    }


    try {
      const payload = {
          id_asignacion_contrato: formData.id_asignacion_contrato,
          tipo_cobertura: formData.tipo_cobertura,
          lugar_ejecucion: formData.lugar_ejecucion,
          cobertura: formData.cobertura,
          plazo_pago: formData.plazo_pago
      };

      const res = await authFetch(
          ENDPOINTS.create_informacion_general,
          {
              method: "POST",
              body: JSON.stringify(payload),
              headers: {
                  "Content-Type": "application/json"
              }
          }
      );

      if (!res.success) {
        setError(res.message);
        return;
      }

      setSuccess("Información general creada correctamente");
      setTimeout(() => {navigate("/session/mod_administrativa/informacion_general/informacion_general");}, 1500);

    } catch (err) {

      console.error(err);
      setError("Error en el servidor");

    }

  };

  return (

    <div className="p-4">

      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center m-3">

        <h3>Crear Información General</h3>

        <button type="button" className="btn btn-outline-pink" onClick={() =>navigate("/session/mod_administrativa/informacion_general/informacion_general")}>
          <i className="bi bi-arrow-left me-1"></i>
          Volver
        </button>

      </div>

      {/* FORM */}

      <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>

        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}

        {success && (
          <div className="alert alert-success">
            {success}
          </div>
        )}

        {/* FILA 0 */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Contrato asignado *</label>

            <SearchSelect
              options={contratoOptions}
              value={formData.id_asignacion_contrato}
              onChange={handleContratoChange}
              placeholder="Buscar contrato..."
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Programa</label>

            <input
              type="text"
              className="form-control"
              value={contratoSeleccionado?.programa || ""}
              readOnly
            />

          </div>

        </div>

        <div className="row">

          <div className="col-md-6 mb-3">

            <label> Número de Contrato / Convenio *</label>
            <input
                type="text"
                className="form-control"
                value={contratoSeleccionado?.num_contrato || ""}
                readOnly
            />
          </div>

        </div>

        {/* FILA 2 */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Tipo cobertura *</label>

            <input
              type="text"
              name="tipo_cobertura"
              className="form-control"
              value={formData.tipo_cobertura}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Contratante *</label>
            <input
              type="text"
              className="form-control"
              value={contratoSeleccionado?.contratante || ""}
              readOnly
            />

          </div>

        </div>

        {/* FILA 3 */}

        <div className="row">

          

          <div className="col-md-6 mb-3">

            <label>Centro de costos</label>

            <input
              type="text"
              className="form-control"
              value={contratoSeleccionado?.cost_center || ""}
              readOnly
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Lugar de ejecución *</label>
            <input
              type="text"
              name="lugar_ejecucion"
              className="form-control"
              value={formData.lugar_ejecucion}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* OBJETO */}

        <div className="row">

          <div className="col-md-6 mb-3">
            <label>Objeto *</label>
            <textarea
                className="form-control"
                rows="3"
                value={contratoSeleccionado?.objeto || ""}
                readOnly
            />
          </div>

          <div className="col-md-6 mb-3">

            <label>Cobertura *</label>
            <input
              type="number"
              name="cobertura"
              min = "0"
              className="form-control"
              value={formData.cobertura}
              onChange={handleChange}
            />

          </div>

        </div>

        {/* FECHAS */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Fecha inicio *</label>
            <input
              type="date"
              className="form-control"
              value={contratoSeleccionado?.fecha_inicio || ""}
              readOnly
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Fecha fin *</label>
            <input
              type="date"
              className="form-control"
              value={contratoSeleccionado?.fecha_fin || ""}
              readOnly
            />

          </div>

        </div>

        {/* FILA 5 */}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Valor contrato antes IVA *</label>
            <input
                  type="text"
                  className="form-control"
                  value={formatoMoneda(contratoSeleccionado?.valor_contrato)}
                  readOnly
              />

          </div>

          <div className="col-md-6 mb-3">

            <label>Plazo de pago *</label>
            <input
              type="text"
              name="plazo_pago"
              className="form-control"
              value={formData.plazo_pago}
              onChange={handleChange}
            />

          </div>

        </div>
        {/* BOTÓN */}

        <button type="submit" className="btn btn-outline-pink w-100 mt-4">
          Crear información general
        </button>

      </form>

    </div>

  );

};

export default CreateInformacionGeneral;